import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Pencil, Settings, LogOut, ChevronDown } from 'lucide-react';
import { useProfile } from '../context/ProfileContext';
import { AVATARS } from '../data/constants';
import { useAuth } from '../context/AuthContext';
import './ProfileDropdown.css';

const ProfileDropdown = () => {
    const navigate = useNavigate();
    const { signOut } = useAuth();
    const { profiles, currentProfile, selectProfile, loading } = useProfile();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Auto-create default profile if none exists


    // Auto-select first profile if none selected
    useEffect(() => {
        if (!loading && profiles.length > 0 && !currentProfile) {
            selectProfile(profiles[0]);
        }
    }, [loading, profiles, currentProfile, selectProfile]);

    const handleProfileClick = (profile) => {
        selectProfile(profile);
        setIsOpen(false);
    };

    const handleManageProfiles = () => {
        setIsOpen(false);
        navigate('/profiles');
    };

    const handleSettings = () => {
        setIsOpen(false);
        navigate('/profile');
    };

    const handleSignOut = async () => {
        setIsOpen(false);
        await signOut();
        navigate('/');
    };

    const currentAvatar = currentProfile?.avatar_url || AVATARS[0];

    return (
        <div className="profile-dropdown" ref={dropdownRef}>
            <button
                className="profile-dropdown-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <img src={currentAvatar} alt="Profile" className="profile-avatar" />
                <ChevronDown size={16} className={`dropdown-arrow ${isOpen ? 'open' : ''}`} />
            </button>

            {isOpen && (
                <div className="profile-dropdown-menu">
                    {/* Profile List */}
                    <div className="dropdown-section profiles-list">
                        {profiles.map((profile) => (
                            <button
                                key={profile.id}
                                className={`profile-option ${currentProfile?.id === profile.id ? 'active' : ''}`}
                                onClick={() => handleProfileClick(profile)}
                            >
                                <img src={profile.avatar_url || AVATARS[0]} alt={profile.name} />
                                <span>{profile.name}</span>
                            </button>
                        ))}
                    </div>

                    {/* Actions */}
                    <div className="dropdown-section">
                        <button className="dropdown-action" onClick={handleManageProfiles}>
                            <Pencil size={18} />
                            <span>Gérer les profils</span>
                        </button>
                    </div>

                    <div className="dropdown-divider"></div>

                    {/* Settings & Logout */}
                    <div className="dropdown-section">
                        <button className="dropdown-action" onClick={handleSettings}>
                            <Settings size={18} />
                            <span>Paramètres</span>
                        </button>
                        <button className="dropdown-action" onClick={handleSignOut}>
                            <LogOut size={18} />
                            <span>Déconnexion</span>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileDropdown;
